export default "__VITE_ASSET__ptO_bk36__"